import toast from "react-hot-toast";
import { IToastMessageConfig } from "@miplatform/types";
import { MiToast, TOAST_TYPES } from "./MiToast";

const removeDelay = 250;

export const toastService = {
  [TOAST_TYPES.INFO]: (props: IToastMessageConfig,) => {
    toast.custom((t) => <MiToast {...props} type={TOAST_TYPES.INFO} t={t} />, {
      id: props.text,
      removeDelay,
    });
  },
  [TOAST_TYPES.SUCCESS]: (props: IToastMessageConfig) => {
    toast.custom(
      (t) => <MiToast {...props} type={TOAST_TYPES.SUCCESS} t={t} />,
      {
        id: props.text,
        removeDelay,
      }
    );
  },
  [TOAST_TYPES.WARNING]: (props: IToastMessageConfig) => {
    toast.custom(
      (t) => <MiToast {...props} type={TOAST_TYPES.WARNING} t={t} />,
      {
        id: props.text,
        removeDelay,
        duration: props.duration,
      }
    );
  },
  [TOAST_TYPES.ERROR]: (props: IToastMessageConfig) => {
    toast.custom((t) => <MiToast {...props} type={TOAST_TYPES.ERROR} t={t} />, {
      id: props.text,
      removeDelay,
    });
  },
};
